import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CircularProgress, TextField } from "@mui/material";

export default function OfficeDialog(props) {
	return (
		<React.Fragment>
			<Dialog
				onKeyDown={(e) => {
					if (props.searchedByCCID && e.key === "Enter") {
						e.preventDefault();
						props.handleConfirmOfficeInstructor();
					}
				}}
				open={props.open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="xl"
			>
				<DialogTitle id="alert-dialog-title">Enter your CCID and click Search</DialogTitle>
				<DialogContent className="flex flex-col gap-2">
					<DialogContentText id="alert-dialog-description">
						Since the adoption of Single-Sign-On (SSO), we are now using an in-office CCID search to
						link your exam requests instead of having you sign in.
					</DialogContentText>
					<DialogContentText id="alert-dialog-description">
						If you access the system from your own device, the login flow will be the same as it was
						previously.
					</DialogContentText>
					{props.searchedByCCID ? (
						<form
							onSubmit={(e) => {
								e.preventDefault();
								props.handleConfirmOfficeInstructor();
							}}
							className="bg-gray-200 rounded-md p-2 flex gap-2"
						>
							<div className="flex flex-col gap-1 w-full items-center">
								<span className="underline underline-offset-2">Account Found</span>
								<p>
									<span className="font-medium">CCID: </span>
									{props.searchState.ccid}
								</p>
								<p>
									<span className="font-medium">EMAIL: </span>
									{props.searchState.email}
								</p>
								<p>
									<span className="font-medium">NAME: </span>
									{props.searchState.firstName} {props.searchState.lastName}
								</p>
								<Button
									type="submit"
									variant="contained"
									color="primary"
									onClick={props.handleConfirmOfficeInstructor}
									sx={{
										width: "100%",
										height: "100%",
										fontWeight: 600,
									}}
								>
									CONFIRM
								</Button>
							</div>
						</form>
					) : (
						<>
							<TextField
								autoFocus
								margin="dense"
								error={props.searchError}
								id="ccidString"
								label="CCID"
								type="text"
								fullWidth
								slotProps={{
									htmlInput: {
										autocomplete: "new-password",
										autoCorrect: "off",
										form: {
											autocomplete: "off",
										},
									},
								}}
								autoCorrect="off"
								variant="filled"
								onChange={(e) => {
									props.setCCIDString(e.target.value);
									props.setSearchError(false);
								}}
								value={props.ccidString}
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										props.handleSearch();
									}
								}}
							/>
							{props.searchError && (
								<span className="text-red-600">
									Cannot find user. Please check your spelling and ensure there are no extra spaces.
								</span>
							)}
						</>
					)}
				</DialogContent>
				<DialogActions>
					{props.searchedByCCID ? (
						<>
							<Button
								onClick={() => props.setSearchedByCCID(false)}
								color="primaryGold"
								variant="contained"
							>
								BACK
							</Button>
						</>
					) : (
						<Button
							onClick={props.handleSearch}
							disabled={props.loadingSearchByCCID}
							fullWidth
							variant="contained"
						>
							{props.loadingSearchByCCID ? (
								<CircularProgress size={20} sx={{ color: "white" }} />
							) : (
								"Search"
							)}
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
}
